import { Component, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { SpinnerService } from '@services/spinner.service';
import notify from 'devextreme/ui/notify';

interface IData {
  entityId?: number;
  name: string;
  vorname: string;
  telefon: string;
  email: string;
}

@Component({
    selector: 'cz-traeger-zugangsdaten',
    templateUrl: 'traeger-zugangsdaten.component.html',
    standalone: false
})
export class TraegerZugangsatenPopupComponent {

  @ViewChild('dataForm', { static: false }) dataForm: DxFormComponent;

  popupVisible: boolean;
  loading: boolean;
  @Input() entityId: number;
  @Output() onReloadNeeded: EventEmitter<any> = new EventEmitter<any>();

  formData: IData = {
    entityId: null,
    name: '',
    vorname: '',
    telefon: '',
    email: ''
  } as IData;

  constructor(private _ajaxService: AjaxService, private spinnerService: SpinnerService) {
    this.onClickSend = this.onClickSend.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
  }

  onShowing(e) {
    this.loading = false;
    this.formData = {
      entityId: this.entityId,
      name: '',
      vorname: '',
      telefon: '',
      email: ''
    } as IData;
  }

  showPopup() {
    this.popupVisible = true;
  }

  onClickClose() {
    this.popupVisible = false;
  }

  onClickSend() {
    if (this.dataForm.instance.validate().isValid) {
      this.loading = true;
      this.spinnerService.show();
      this._ajaxService.post('api/Traeger/SetExternBenutzer/', this.formData).subscribe(response => {
        if (!response) {
          this.onReloadNeeded.next(true);
          this.spinnerService.hide();
          this.popupVisible = false;
        }
        else {
          notify({
            message: response,
            width: 600
          }, 'error', 3000);
        }
        this.loading = false;
      });
    }
  }
}
